import type { ServiceOption } from '../data/services';

export type LeadCapturePayload = {
  name: string;
  phone: string;
  service: ServiceOption;
};

type LeadCaptureResponse = {
  ok: boolean;
  leadId?: number;
};

function getErrorMessage(error: unknown) {
  if (error instanceof Error) {
    return error.message;
  }

  return 'Nao foi possivel cadastrar o lead.';
}

export async function createLead(endpoint: string, payload: LeadCapturePayload): Promise<LeadCaptureResponse> {
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  let data: unknown = null;

  try {
    data = await response.json();
  } catch (_error) {
    data = null;
  }

  if (!response.ok) {
    const message =
      data && typeof data === 'object' && 'message' in data
        ? String((data as { message: unknown }).message)
        : 'Nao foi possivel cadastrar o lead.';

    throw new Error(message);
  }

  if (data && typeof data === 'object') {
    const leadId = 'leadId' in data ? Number((data as { leadId: unknown }).leadId) : undefined;
    return {
      ok: true,
      leadId: Number.isFinite(leadId) ? leadId : undefined
    };
  }

  return { ok: true };
}

export function getLeadCaptureError(error: unknown) {
  return getErrorMessage(error);
}
